import { render, staticRenderFns } from "./Model14.vue?vue&type=template&id=1bf85984&scoped=true"
import script from "./Model14.vue?vue&type=script&lang=js"
export * from "./Model14.vue?vue&type=script&lang=js"
import style0 from "./Model14.vue?vue&type=style&index=0&id=1bf85984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf85984",
  null
  
)

export default component.exports